import React, { useState } from "react";
import api from "@/lib/api";
import { PageHeader, Section } from "@/components/Primitives";
import { toast } from "sonner";
import { PaperPlaneTilt } from "@phosphor-icons/react";

const CLASS_GROUPS = ["Class 9", "Class 10", "Class 11", "Class 12", "B.Com", "B.Sc", "B.CA"];

export default function TeacherNotify() {
  const [form, setForm] = useState({ title: "", message: "", class_group: "Class 10", send_email: false, send_sms: false, target_role: "student" });
  const [sending, setSending] = useState(false);

  const send = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/notifications/broadcast", form);
      toast.success("Notification queued");
      setForm({ ...form, title: "", message: "" });
    } catch { toast.error("Failed"); }
    finally { setSending(false); }
  };

  return (
    <div>
      <PageHeader eyebrow="Communications" title="Broadcast" />

      <Section>
        <form onSubmit={send} className="card-academic p-6 grid gap-4 max-w-2xl">
          <div>
            <label className="overline block mb-2">Title</label>
            <input required value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} data-testid="n-title"
              className="w-full bg-ivory border border-stone px-4 py-3" />
          </div>
          <div>
            <label className="overline block mb-2">Message</label>
            <textarea required rows={4} value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} data-testid="n-message"
              className="w-full bg-ivory border border-stone px-4 py-3" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="overline block mb-2">Class</label>
              <select value={form.class_group} onChange={e => setForm({ ...form, class_group: e.target.value })} data-testid="n-class"
                className="w-full bg-ivory border border-stone px-4 py-3">
                {CLASS_GROUPS.map(c => <option key={c}>{c}</option>)}
              </select>
            </div>
            <div>
              <label className="overline block mb-2">Audience</label>
              <select value={form.target_role} onChange={e => setForm({ ...form, target_role: e.target.value })} data-testid="n-role"
                className="w-full bg-ivory border border-stone px-4 py-3">
                <option value="student">Students</option>
                <option value="teacher">Teachers</option>
              </select>
            </div>
          </div>
          <div className="flex gap-6">
            <label className="flex items-center gap-2 text-sm">
              <input type="checkbox" checked={form.send_email} onChange={e => setForm({ ...form, send_email: e.target.checked })} data-testid="n-email" /> Also send Email
            </label>
            <label className="flex items-center gap-2 text-sm">
              <input type="checkbox" checked={form.send_sms} onChange={e => setForm({ ...form, send_sms: e.target.checked })} data-testid="n-sms" /> Also send SMS
            </label>
          </div>
          <button disabled={sending} className="btn-primary flex items-center gap-2 justify-center" data-testid="n-send">
            <PaperPlaneTilt size={16} /> {sending ? "Sending…" : "Broadcast"}
          </button>
        </form>
      </Section>
    </div>
  );
}
